export interface IdentityConfig {
  apiUrl: string;
  onLogout: () => void;
  onUnauthenticated: () => void;
  onAuthenticated: () => void;
}

let config: IdentityConfig | undefined;

export function getIdentityConfig(): IdentityConfig {
  if (!config) throw new Error('IdentityConfig not initialized. Wrap your app with IdentityContextProvider.');
  return config;
}

export function setIdentityConfig(value: IdentityConfig) {
  config = value;
}
